import { render, staticRenderFns } from "./region.vue?vue&type=template&id=b3ae285e&scoped=true&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"
import style0 from "./region.vue?vue&type=style&index=0&id=b3ae285e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae285e",
  null
  
)

export default component.exports